import { EMergeKey, EMergeLabel } from '@/editor/types/enums';

export const documentMergeTags = [
  {
    label: EMergeLabel.Name,
    value: EMergeKey.name,
  },
  {
    label: EMergeLabel.Value,
    value: EMergeKey.value,
  },
  {
    label: EMergeLabel.SendDate,
    value: EMergeKey.sendDate,
  },
  {
    label: EMergeLabel.UniqueId,
    value: EMergeKey.uniqueId,
  },
];
